import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { API_URL } from "..";

const PurchasePaymentListLayer = ({ paymentsData = [] }) => {
  const tableRef = useRef(null);
  const history = useNavigate();

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Payment?")) return;
    try {
      const res = await fetch(`${API_URL}/api/purchase-payments/${id}`, { method: "DELETE" });
      if (res.ok) window.location.reload();
    } catch (err) {
      alert("Error deleting payment: " + err.message);
    }
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#dataTable")) {
      $("#dataTable").DataTable().destroy(true);
    }

    tableRef.current = $("#dataTable").DataTable({
      data: paymentsData,
      responsive: true,
      pageLength: 10,
      columns: [
        { data: "payment_date", title: "Payment Date" },
        {
          data: "Supplier",
          title: "Supplier",
          render: (supplier) => supplier?.name || "N/A",
        },
        {
          data: "PurchaseBill",
          title: "Bill",
          render: (bill) => bill?.bill_number || "N/A",
        },
        { data: "payment_method", title: "Method" },
        {
          data: "amount",
          title: "Amount",
          render: (data) => `Rs. ${parseFloat(data).toLocaleString()}`,
        },
        { data: "remarks", title: "Remarks" },
        {
          data: null,
          title: "Actions",
          render: (data, type, row) => `
            <div class="dropdown">
              <button class="dropdown-toggle" data-bs-toggle="dropdown"><i class="ph ph-list"></i></button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View</a></li>
                <li><a class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete</a></li>
              </ul>
            </div>
          `,
        },
      ],
    });

    $("#dataTable tbody").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/view-purchase-payment/${id}`);
    });

    $("#dataTable tbody").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      handleDelete(id);
    });

    return () => {
      if ($.fn.DataTable.isDataTable("#dataTable")) $("#dataTable").DataTable().destroy(true);
    };
  }, [paymentsData]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Purchase Payments</h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info" to="/add-payment">Add New</Link>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="dataTable"></table>
      </div>
    </div>
  );
};

export default PurchasePaymentListLayer;
